'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { ErrorBoundary, } from '@sentry/react';
import {} from 'react';
import DefaultErrorBoundaryFallback from '../../components/default-error-boundary-fallback/index.js';
import useSentry from './sentry.hook.js';
export default function Sentry({ beforeErrorBoundaryCapture, children, errorBoundaryDialogOptions, ErrorBoundaryFallback = DefaultErrorBoundaryFallback, onErrorBoundaryError, onErrorBoundaryMount, onErrorBoundaryReset, onErrorBoundaryUnmount, showErrorBoundaryDialog, user, ...browserOptions }) {
    useSentry({
        user,
        ...browserOptions,
    });
    return (_jsx(ErrorBoundary, { beforeCapture: beforeErrorBoundaryCapture, dialogOptions: errorBoundaryDialogOptions, fallback: ErrorBoundaryFallback, onError: onErrorBoundaryError, onMount: onErrorBoundaryMount, onReset: onErrorBoundaryReset, onUnmount: onErrorBoundaryUnmount, showDialog: showErrorBoundaryDialog, children: children }));
}
//# sourceMappingURL=sentry.view.js.map